<template>
	<div class="view">
		DragTarget
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>

</style>